import { createAction, props } from '@ngrx/store';
import {MultiviewParameters} from '../../../services/api/multiviews/multiviews.service';
import {MultiviewView} from '../../../services/api/multiviews/multiview.view.model';

export const loadGrid = createAction(
  '[Grid] Load Grid',
  props<{ data: MultiviewParameters }>()
);

export const loadGridSuccess = createAction(
  '[Grid] Load Grid Success',
  props<{ data: MultiviewView }>()
);

export const loadUpdatedGridSuccess = createAction(
  '[Grid] Load Updated Grid Success',
  props<{ data: any }>()
);

export const loadGridFailure = createAction(
  '[Grid] Load Grid Failure',
  props<{ error: any }>()
);

export const updateVisibility = createAction(
  '[Grid] Update Visibility',
);

export const clearGridState = createAction(
  '[Grid] clear Grid State',
);
